import React from 'react'
import { useIntl } from 'react-intl'
import { mdiCheckCircleOutline } from '@mdi/js'

import theme from 'theme_'
import { MdiIcon } from 'components/Icons'
import { ResentWrapper, TwoFaInputWrapper, StyledProceedButton } from './styles'
import { loginMessages } from '../../messages'

import LoginCommonLayout from '../LoginCommonLayout'
import { StyledMainHeading } from '../MainHeading/MainHeading'
import { ResentSuccessProps } from '../../types'

export default function ResentSuccess(props: ResentSuccessProps) {
  const { formatMessage } = useIntl()

  const { setResent } = props

  return (
    <LoginCommonLayout>
      <StyledMainHeading>
        {formatMessage(loginMessages.resendVerificationSuccessHeader)}
      </StyledMainHeading>
      <TwoFaInputWrapper>
        <MdiIcon
          path={mdiCheckCircleOutline}
          color={theme.colors.green}
          size={3}
        />
      </TwoFaInputWrapper>

      <ResentWrapper>
        <StyledProceedButton
          type="button"
          variant="primary"
          onClick={() => setResent(false)}
        >
          {formatMessage(loginMessages.proceedButton)}
        </StyledProceedButton>
      </ResentWrapper>
    </LoginCommonLayout>
  )
}
